/**
 * AdminAuthProvider - Auth context for the admin dashboard with role checking.
 */

import type { ReactNode } from 'react'
import { AdminAuthContext } from './admin-auth-context.js'
import { useAdminAuth } from './useAdminAuth.js'

interface AdminAuthProviderProps {
  children: ReactNode
}

export function AdminAuthProvider({ children }: AdminAuthProviderProps) {
  const auth = useAdminAuth()
  return <AdminAuthContext.Provider value={auth}>{children}</AdminAuthContext.Provider>
}
